module.exports = __webpack_public_path__ + "static/media/serving.e094dfc5.svg";